export enum TAGMAN_IDS {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Dev = 'https://tagman.rheinenergie.com/js/container_DGz1tCDW_dev_b9d4551089ec6688afe454c9.js',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Test = 'https://tagman.rheinenergie.com/js/container_DGz1tCDW_dev_b9d4551089ec6688afe454c9.js',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Prod = 'https://tagman.rheinenergie.com/js/container_DGz1tCDW.js'
}
